import 'containers/OmonymsFrame/index.scss';
import SvgObject from 'containers/OmonymsFrame/SvgObject';
import React, {FC, useCallback} from 'react';
import {flatBem} from 'utils/bem';
import {Configurator} from 'utils/makeConfigurator';

const b = flatBem('OmonymsFrame');

type Props = {
  data: {svg: string};
  conf: Configurator;
};

const Component: FC<Props> = ({data, conf}) => {
  const svgParentRef = useCallback(
    node => {
      if (node === null) return;
      new SvgObject(data.svg, node, conf('isMobile', false)).activate();
    },
    [data.svg, conf],
  );
  return (
    <div className={b()}>
      <div className={b('title')}>Слова, изменившие основное значение</div>
      <div className={b('text-after-title')}>
        Примеры слов, которые в дневниковых записях первых сорока лет XX века и в статьях и
        комментариях в современных блогах употребляются в основном разных смыслах.
      </div>
      <div className={b('svg-parent')} ref={svgParentRef} />
      <div className={b('copyright')}>
        <div className={b('copyright-left')}>
          По данным Яндекс.Дзена, 2019–2021, и центра <a href="https://prozhito.org/">Прожито</a>{' '}
          ЕУСПб, 1900–1940.
        </div>
        <div className={b('copyright-mid')} />
        <div className={b('copyright-right')}>
          <a href="">Скачать таблицу</a> со 100 словами, сменившими основное значение
        </div>
      </div>
    </div>
  );
};

export default Component;
